{
  "whatsNew.updates.more-natural-interview-voices.title": "More natural voices, more choice",
  "whatsNew.updates.more-natural-interview-voices.summary": "Our upgraded voice model brings more natural speech and multilingual accents, better pronunciation in context, and more American female voices to choose from.",
  "account.fullAccess": "Full Access",
  "account.label": "Account",
  "account.logout": "Logout",
  "account.orgPhoneNumbers": "Org Phone Numbers",
  "account.reportIssue": "Report Issue",
  "account.reportIssueLoading": "Report Issue...",
  "account.storageUnavailable": "Browser storage is unavailable. Open this page in a regular browser tab to switch users.",
  "account.switchUser": "Switch User",
  "account.userSettings": "User Settings",
  "errorBoundary.sectionDescription": "The rest of this page is still available.",
  "errorBoundary.sectionTitle": "This section failed to load",
  "nav.admin": "Admin",
  "nav.analytics": "Analytics",
  "nav.alerts": "Alerts",
  "nav.assistant": "Tenzo assistant",
  "nav.auditLog": "Audit Log",
  "nav.billing": "Billing",
  "nav.closeNavigation": "Close navigation",
  "nav.documentation": "Documentation",
  "nav.devDocumentation": "Dev documentation",
  "nav.feedback": "Feedback",
  "nav.interviews": "Interviews",
  "nav.jobs": "Jobs",
  "nav.logoAlt": "Tenzo logo",
  "nav.meetingCopilot": "Meeting Copilot",
  "nav.openNavigation": "Open navigation",
  "nav.pages": "Pages",
  "nav.questions": "Questions",
  "nav.sourcing": "Sourcing",
  "phoneBanner.message": "Your organization has no dedicated phone number registered. Please contact support to set one up.",
  "phoneBanner.title": "No dedicated phone number",
  "search.candidateJob": "Job: <anchor>{{job}}</anchor>",
  "search.emptyHint": "Enter a search term to find matching jobs and candidates across your organization",
  "search.modalPlaceholder": "Search jobs and candidates...",
  "search.open": "Open search",
  "search.searchCandidates": "<label>Search Candidates:</label> {{query}}",
  "search.searchJobs": "<label>Search Jobs:</label> {{query}}",
  "search.unknownCandidate": "Unknown Candidate",
  "search.unknownJob": "Unknown Job",
  "search.untitledJob": "Untitled Job",
  "smsDeadline.askAdmin": "Ask an admin to complete SMS registration.",
  "smsDeadline.dueInDays_one": "SMS registration is due in {{count}} day. Submit it before then to keep adding candidates.",
  "smsDeadline.dueInDays_other": "SMS registration is due in {{count}} days. Submit it before then to keep adding candidates.",
  "smsDeadline.dueToday": "SMS registration is due today. Submit it before then to keep adding candidates.",
  "smsDeadline.goToRegistration": "Go to SMS Registration",
  "smsDeadline.overdueTitle": "SMS registration overdue",
  "smsDeadline.paused": "Adding candidates is paused until SMS registration is submitted.",
  "smsDeadline.requiredTitle": "SMS registration required",
  "bulkToast.failed": "Failed to process items",
  "bulkToast.error.cancelled": "The operation stopped before it finished. Please try again.",
  "bulkToast.error.connection": "Lost connection to the operation's progress. Refresh the page to check its status.",
  "bulkToast.error.failed": "The operation failed. Please try again.",
  "bulkToast.error.notFound": "This operation could not be found.",
  "bulkToast.failedCount_one": "{{count}} failed",
  "bulkToast.failedCount_other": "{{count}} failed",
  "bulkToast.partial_one": "Processed {{count}} item, {{failed}} failed",
  "bulkToast.partial_other": "Processed {{count}} items, {{failed}} failed",
  "bulkToast.processedOf": "{{processed}} / {{total}} processed",
  "bulkToast.success_one": "Successfully processed {{count}} item",
  "bulkToast.success_other": "Successfully processed {{count}} items",
  "support.backToLogin": "Back to login",
  "support.badge": "Support",
  "support.findByEntityId": "Find organization by entity ID",
  "support.redirectNotice": "After switching, you will be redirected to: <bold>{{path}}</bold>",
  "support.subtitle": "Enter an email to impersonate",
  "support.title": "Super user access",
  "support.userListLoadFailed": "Failed to load the user list from the server.",
  "support.userLookupFailed": "Failed to get the user from the server.",
  "support.userPlaceholder": "Search and select a user",
  "appUpdate.title": "New version available",
  "appUpdate.body": "A new app version is available. Reload to update.",
  "nav.externalAgent": "External agent",
  "nav.docsOpenFailed": "Could not open documentation. Please try again.",
  "account.supportLanguage": "Support display language",
  "account.supportLanguageDefault": "Use mocked user's language",
  "account.supportLanguageDescription": "Changes the app UI for this support session only.",
  "whatsNew.dismiss": "Dismiss",
  "whatsNew.dismissError": "Couldn't save that you closed this. Try again.",
  "whatsNew.eyebrow": "What's new",
  "whatsNew.loadError": "What's new couldn't be loaded.",
  "whatsNew.readChangelog": "Read product updates",
  "whatsNew.readFullUpdate": "Read full update",
  "whatsNew.updates.whats-new-in-tenzo.title": "What's new in Tenzo",
  "whatsNew.updates.whats-new-in-tenzo.summary": "Major updates to the Tenzo Platform will appear in this notification card. Click the link in the bottom of the card to read the full update in the Tenzo docs.",
  "whatsNew.updates.reuse-recent-interview-answers.title": "Reuse recent interview answers from one setting",
  "whatsNew.updates.reuse-recent-interview-answers.summary": "One settings toggle now covers both allowing the AI interviewer to **skip individual questions** the candidate recently answered from an interview for another role or **skipping an entirely redundant recent interview** altogether.",
  "whatsNew.updates.screening-question-setup.title": "A cleaner screening questions editor",
  "whatsNew.updates.screening-question-setup.summary": "The screening questions editor got a cleanup, with a more compact display, and fewer icons cluttering the view.",
  "whatsNew.updates.sourcing-voice-feedback.title": "Talk through sourcing results",
  "whatsNew.updates.sourcing-voice-feedback.summary": "Speak what you like and don't like as you browse candidates, then choose which requirement changes to apply.",
  "whatsNew.updates.sourcing-search-filters.title": "More ways to narrow a sourcing search",
  "whatsNew.updates.sourcing-search-filters.summary": "Choose which **prior submittals** to include, hide people already in an interview, search by country or state, and see who was screened before.",
  "whatsNew.updates.display-language.title": "Choose the language of the app",
  "whatsNew.updates.display-language.summary": "Each person can pick a **display language**, and an admin sets the default for anyone who has not chosen one.",
  "whatsNew.updates.analytics-page.title": "A sleeker Analytics page",
  "whatsNew.updates.analytics-page.summary": "The same default charts, in a more compact layout. Click any chart to see and download the data behind it, and drag **custom charts** to rearrange or resize them.",
  "whatsNew.tags.announcements": "Announcements"
}
